import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  CreateBookForMePayload,
  handleCreateBookForMeAction,
  handleGetBookForMeAction,
  HandleGetBookForMeActionProps,
} from "@/actions/book-for-me.action";

/** ******************************
 * Book for me query keys
 ****************************** */
const bookForMeQueryKeys = {
  all: () => ["book-for-me"] as const,
  list: (params: HandleGetBookForMeActionProps) =>
    ["book-for-me", "list", params] as const,
};

/** ******************************
 * Book for me list
 ****************************** */
const useGetBookForMeList = (
  params: HandleGetBookForMeActionProps,
  enabled = true,
) => {
  return useQuery({
    queryKey: bookForMeQueryKeys.list(params),
    queryFn: () => handleGetBookForMeAction(params),
    enabled,
    staleTime: 60 * 1000,
    select: (res) => res.data,
  });
};

/** ******************************
 * Handle: create book for me
 ****************************** */
const useCreateBookForMe = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateBookForMePayload) =>
      handleCreateBookForMeAction(payload),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: bookForMeQueryKeys.all() }),
  });
};

export { bookForMeQueryKeys, useGetBookForMeList, useCreateBookForMe };
